import * as COLORS from '../utils/colors';

function setCssVar(name, value) {
  try {
    document.documentElement.style.setProperty(name, value);
  } catch (e) {
    // silent fail for server-side rendering contexts
  }
}

function flattenAndSet(obj, path = []) {
  Object.entries(obj).forEach(([key, value]) => {
    if (value && typeof value === 'object') {
      flattenAndSet(value, path.concat(key));
    } else {
      const varName = `--color-${path.concat(key).join('-').toLowerCase()}`;
      setCssVar(varName, value);
    }
  });
}

export default function injectColorsVars() {
  // Iterate over all named exports from src/utils/colors.js
  Object.entries(COLORS).forEach(([namespace, value]) => {
    if (value && typeof value === 'object') {
      flattenAndSet(value, [namespace.replace(/_?COLORS$/i, '').toLowerCase()]);
    }
  });

  // Convenience top-level aliases
  if (COLORS.BRAND_COLORS && COLORS.BRAND_COLORS.primary) {
    setCssVar('--color-primary', COLORS.BRAND_COLORS.primary);
  }
  if (COLORS.BRAND_COLORS && COLORS.BRAND_COLORS.secondary) {
    setCssVar('--color-secondary', COLORS.BRAND_COLORS.secondary);
  }
  if (COLORS.TEXT_COLORS && COLORS.TEXT_COLORS.primary) {
    setCssVar('--color-text-primary', COLORS.TEXT_COLORS.primary);
  }
  if (COLORS.BACKGROUND_COLORS && COLORS.BACKGROUND_COLORS.primary) {
    setCssVar('--color-bg-primary', COLORS.BACKGROUND_COLORS.primary);
  }
  if (COLORS.BORDER_COLORS && COLORS.BORDER_COLORS.default) {
    setCssVar('--color-border-default', COLORS.BORDER_COLORS.default);
  }

  // Convenience aliases for semantic colors
  if (COLORS.SEMANTIC_COLORS) {
    setCssVar('--color-success', COLORS.SEMANTIC_COLORS.success);
    setCssVar('--color-success-light', COLORS.SEMANTIC_COLORS.successLight || COLORS.SEMANTIC_COLORS.success);
    setCssVar('--color-success-dark', COLORS.SEMANTIC_COLORS.successDark || COLORS.SEMANTIC_COLORS.success);

    setCssVar('--color-error', COLORS.SEMANTIC_COLORS.error);
    setCssVar('--color-error-light', COLORS.SEMANTIC_COLORS.errorLight || COLORS.SEMANTIC_COLORS.error);
    setCssVar('--color-error-dark', COLORS.SEMANTIC_COLORS.errorDark || COLORS.SEMANTIC_COLORS.error);

    setCssVar('--color-warning', COLORS.SEMANTIC_COLORS.warning);
    setCssVar('--color-warning-light', COLORS.SEMANTIC_COLORS.warningLight || COLORS.SEMANTIC_COLORS.warning);
    setCssVar('--color-warning-dark', COLORS.SEMANTIC_COLORS.warningDark || COLORS.SEMANTIC_COLORS.warning);

    setCssVar('--color-info', COLORS.SEMANTIC_COLORS.info);
    setCssVar('--color-info-light', COLORS.SEMANTIC_COLORS.infoLight || COLORS.SEMANTIC_COLORS.info);
    setCssVar('--color-info-dark', COLORS.SEMANTIC_COLORS.infoDark || COLORS.SEMANTIC_COLORS.info);
  }
}
